var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileuploaditem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "130px",
    height: "130px",
    viewBox: "0 0 130 130",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "inputfieldItem") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "inputfieldItem",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2FB37",
    x: 0,
    y: 0,
    width: 130,
    height: 130,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "np_upload_3136046_000000",
    transform: "translate(18.000000, 18.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.6915865,59 C37.8952886,58.6526845 37.4402961,57.8065909 37.5833678,56.9456564 L37.5833678,27.3984464 L37.5833678,26.1126254 L28.5746411,26.1126254 L27.5324628,26.1126254 C25.9252311,25.950058 25.5582047,25.2332559 26.5453338,23.984409 C32.39831,16.5467185 38.2588016,9.13135063 44.1592179,1.76393855 C46.0857541,-0.630257549 46.9774394,-0.54531807 49.0250652,1.76393855 C55.0944809,8.89497674 61.1565692,16.0296092 67.2110483,23.1681198 C67.5486524,23.6927866 67.8128607,24.2580504 68,24.8529105 C67.4238804,25.1004646 66.8184137,25.2741176 66.1982171,25.3627933 C63.2295026,25.4182158 60.260882,25.3627933 57.2921675,25.3627933 L56.1839489,25.3627933 L56.1839489,26.404768 L56.1839489,56.9754136 C56.3123847,57.8178278 55.8279982,58.6380708 55.0280084,58.9225897 L38.6907786,58.9225897 L38.6915865,59 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0552778358,60 L13.0281659,60 L13.0281659,81.3383862 L80.935374,81.3383862 L80.935374,60.0076575 L93.9449219,60.0076575 C93.9449219,60.3378513 94,60.6570467 94,60.946882 L94,87.0836227 C94,91.3834866 91.2828469,93.9957518 86.8471926,93.9957518 L7.06877211,93.9994214 C3.57311411,94.0361094 1.10938397,92.3264746 0.264797357,89.3400223 C0.081206692,88.6759624 -0.0069179551,87.989887 0,87.3001205 L0,60.7961431 C0,60.5613369 0,60.3191955 0.0555015549,60 L0.0552778358,60 Z",
    id: "Path"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileuploaditem);
export default __webpack_public_path__ + "static/media/fileuploaditem.ed24b314ebfb83564e3cb09dbc4f3296.svg";
export { ForwardRef as ReactComponent };